import $ from 'jquery';

(function (window, document) {
	// Defaults.
	var r4 = (window.r4 = {
		utils: {},
		cache: {},
	});

	// Methods.
	r4.utils.init = function () {
		r4.cache.window = $(window);
		r4.cache.document = $(document);
		r4.cache.html = $('html');
		r4.cache.body = $('body');
		r4.cache.header = r4.cache.body.find('header');

		// Media queries.
		r4.mobile = false;
		r4.bounds = [
			[
				1000,
				10000,
				function () {
					window.mobile = false;
				},
			],
			[
				0,
				1000,
				function () {
					window.mobile = true;
				},
			],
		];
		r4.lastBound = -1;
	};

	// Resize.
	r4.utils.resize = function () {
		r4.utils.calcBounds(r4.cache.window, r4.bounds, r4.lastBound);
	};

	// Resize methods.
	r4.utils.calcBounds = function (ths, bounds, lastBound) {
		var width = ths.width();

		for (var i = 0, j = bounds.length; i < j; i++) {
			if (width > bounds[i][0] && width < bounds[i][1] && lastBound !== i) {
				bounds[i][2]();
				lastBound = i;
			}
		}
	};

	// TABLE / MOBILE - SUBMENU
	/*r4.utils.submenu = function(){
        $('.submenu-item > a').on('click', function(e){
            e.preventDefault();

            //console.log($(this).parent().hasClass('submenu-item-act'));

            if ($(this).parent().hasClass('submenu-item-act')) {
                $('.submenu-item-act').removeClass('submenu-item-act');
            } else {
                $('.submenu-item-act').removeClass('submenu-item-act');

                $(this).parent().toggleClass('submenu-item-act');
            }
        });

    };*/

	r4.utils.domLoad = function () {
		r4.utils.resize();
		// noinspection JSUnresolvedFunction
		r4.cache.window.smartresize(function () {
			r4.utils.resize();
		});

		//r4.utils.submenu();
	};

	// Initialize Events.
	r4.utils.init();
	jQuery(function () {
		r4.utils.domLoad();
	});
})(window, document);

// Debouncing function from John Hann.
// http://unscriptable.com/index.php/2009/03/20/debouncing-javascript-methods/
(function ($, sr) {
	var debounce = function (func, threshold, execAsap) {
		var timeout;

		return function debounced() {
			var obj = this,
				args = arguments;

			function delayed() {
				if (!execAsap) {
					func.apply(obj, args);
				}

				timeout = null;
			}

			if (timeout) {
				clearTimeout(timeout);
			} else if (execAsap) {
				func.apply(obj, args);
			}

			timeout = setTimeout(delayed, threshold || 100);
		};
	};

	jQuery.fn[sr] = function (fn) {
		return fn ? this.bind('resize', debounce(fn)) : this.trigger(sr);
	};
})(jQuery, 'smartresize');
